import React, { PropTypes, Component } from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import { getValueFromQueryString } from '../../util/sharedFunctions';
import PinPad from './pinPad';

class SetPassword extends Component {

  constructor(props) {
    super(props);

    let code = getValueFromQueryString(this.props.location.search, 'code');//cuz the .query strips the '+' characters we have to get the 'code' the hard way
    let userId = getValueFromQueryString(this.props.location.search, 'userId');

    this.state = { pin: '', confirmPin: '', code: code, userId: userId, doesntMatch: false };
    this.handleChildUnmount = this.handleChildUnmount.bind(this);

  }

  componentDidMount() {

  }

  handleSubmit(values) {
    this.props.onConfirm(values);
  }

  pinComplete(pin) {
    this.setState({ pin: pin });
  }
  confirmPinComplete(confirmPin) {
    this.setState({ confirmPin: confirmPin });
    if (this.state.pin !== confirmPin) {
      this.setState({ doesntMatch: true });
    }
  }

  submit() {
    this.props.onSubmit(this.state);
  }
  handleChildUnmount() {
    this.setState({ clearInputs: false });
  }

  clear() {
    this.setState({ clearInputs: true });
    setTimeout(function () {
      this.setState({ clearInputs: false, doesntMatch: false, pin: '', confirmPin: '' });
    }.bind(this), 100);
  }

  render() {
    let confirmPinEnabled = this.state.pin ? true : false;
    let confirmButtonEnabled = this.state.pin && (this.state.pin === this.state.confirmPin);

    return (
      <form >
        <h2 className="client-text text-center">Set PIN</h2>
        <div className="row">
          <div className="col-md-12">
            <div className="card text-center">
              <p><i className="login-icon fa fa-lock" /> PIN</p>
              {!this.state.clearInputs && <PinPad ref="pinPad1" strength={4} pinComplete={this.pinComplete.bind(this)} autoFocus={true} enabled={true} unmountMe={this.handleChildUnmount} />}
              <p className="m-t-15"><i className="login-icon fa fa-lock" /> Confirm PIN</p>
              {!this.state.clearInputs && <PinPad ref="pinPad2" strength={4} pinComplete={this.confirmPinComplete.bind(this)} autoFocus={true} enabled={confirmPinEnabled} unmountMe={this.handleChildUnmount} />}
            </div>
          </div>
        </div>
        {
          this.state.doesntMatch &&
          <div className="well m-t-20">
            PIN numbers doesn't match!
                    </div>
        }
        <button disabled={!confirmButtonEnabled} className="btn btn-client btn-lg btn-block" onClick={this.submit.bind(this)} type="button">
          Update PIN
        </button>
        <button className="btn btn-client btn-lg btn-block" onClick={this.clear.bind(this)} type="button">
          Clear
        </button>
      </form>
    );

  }
}


export default SetPassword;



// WEBPACK FOOTER //
// ./app/auth/components/setPassword.js